import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

/* global __APP_BUILD_ID__ */
// Cache-bust locale JSON per build. Locale files live at stable URLs
// (/locales/{{lng}}/{{ns}}.json) so browsers/CDNs cache them; without a
// version key an updated translation stays stale until the cache expires.
// __APP_BUILD_ID__ is injected by vite (see vite.config.js) and changes
// every build, so each deploy fetches fresh copies.
const BUILD_ID =
  typeof __APP_BUILD_ID__ !== 'undefined' ? __APP_BUILD_ID__ : 'dev';

const NAMESPACES = [
  'common',
  'navigation',
  'auth',
  'onboarding',
  'forms',
  'validation',
  'profile',
  'dashboard',
  'pipeline',
  'documents',
  'tools',
  'chat',
  'dashboardAdmin',
  'activityLog',
];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    // i18next v25 stops splitting 'ns:key' when the key contains a space
    // (natural-language-key heuristic), which broke every multi-word literal
    // key like t('profile:First Name') (PROD-652). An explicit nsSeparator
    // restores the classic parsing.
    nsSeparator: ':',
    debug: false,
    lng: 'en',
    ns: NAMESPACES,
    defaultNS: 'common',
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${BUILD_ID}`,
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'cookie'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
    },
  })
  .then(() => {
    i18n.loadNamespaces(NAMESPACES);
  });

i18n.on('languageChanged', (lng) => {
  i18n.reloadResources(lng, NAMESPACES);
});

export default i18n;
